/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable import/no-cycle */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable object-curly-newline */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-void */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import useMediaQuery from "@mui/material/useMediaQuery";

import { CARD_LIST_PER_PAGE, CAREER_TYPE_ELEARNING } from "../../../../Constants";

import NoData from "../../../../component/NoData";
import ToListButton from "../../../../component/button/ToListButtonVertical";
import SompoLoading from "../../../../component/loading/SompoLoading";
import ThumbnailBox from "./ThumbnailBox";
import { HomeProps } from "../../Home";

import SearchCareerClassListService, { CareerResultsItem } from "../../../../logic/api/SearchCareerClassListService";
import SompoContext from "../../../../logic/context/SompoContext";
import { asc, desc, chainedSort } from "../../../../logic/utility/sort";

const Submission = (props: HomeProps) => {
    const { categories, careers: homeCareers } = props;
    const { getSubmissionCategoryId, isSubmission } = categories;
    const categoryId = getSubmissionCategoryId();
    // console.log("Submission: getSubmissionCategoryId", categoryId);

    const sompoContext = React.useContext(SompoContext);
    const navigate = useNavigate();
    const matches: boolean = useMediaQuery("(max-width:900px)");

    const [careers, setCareers] = useState<CareerResultsItem[]>([]);

    const clearSearchContext = () => sompoContext.setSearchText("");

    useEffect(() => {
        // 分類IDが未設定の場合は何もしない
        // console.log("Submission: useEffect", categoryId);
        if (!categoryId) {
            return;
        }

        // 検索結果から情報発信を抜粋
        const applicable: CareerResultsItem[] = [];

        for (const item of homeCareers || []) {
            if (String(item.careerTypeId) !== CAREER_TYPE_ELEARNING || !isSubmission(item.careerId)) continue;
            applicable.push(item);
        }
        const filteredKikanExists = applicable.filter((value) => (value.displayStartDateTime || "") !== "");
        const filteredKikanNotExists = applicable.filter((value) => (value.displayStartDateTime || "") === "");

        const sortedKikan = filteredKikanExists.sort((a, b) =>
            chainedSort(
                a,
                b,
                (_a, _b) => desc(a.displayStartDateTime, b.displayStartDateTime),
                (_a, _b) => asc(a.careerTitle, b.careerTitle)
            )
        );
        const sortedTitle = filteredKikanNotExists.sort((a, b) => asc(a.careerTitle, b.careerTitle));

        const result = sortedKikan.concat(sortedTitle);

        setCareers(result);
    }, [categoryId]);

    return (
        <Box
            sx={{
                width: "100%",
                height: "auto",
                mt: 2,
            }}
        >
            <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", pb: 2 }}>
                <Typography variant="h5">情報発信</Typography>
                {careers && (
                    <ToListButton
                        preNavigate={clearSearchContext}
                        navigateUrl={"/trainingList"}
                        state={{ categoryId: getSubmissionCategoryId(), parentCategoryId: getSubmissionCategoryId() }}
                    />
                )}
            </Box>
            <List
                sx={{
                    width: "100%",
                    height: "auto",
                    p: 0,
                }}
            >
                {sompoContext.loading ? (
                    <SompoLoading position="relative" />
                ) : (
                    <>
                        {(careers || []).length > 0 ? (
                            <>
                                {careers.slice(0, matches ? 3 : CARD_LIST_PER_PAGE).map((row, index) => (
                                    <Box key={index} sx={{ width: "100%" }}>
                                        <ListItem
                                            key={index}
                                            sx={{
                                                p: 0,
                                                width: "100%",
                                                height: "auto",
                                            }}
                                        >
                                            <ListItemButton
                                                sx={{
                                                    width: "100%",
                                                    height: "auto",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    transition: "all 0.18s ease-in-out",
                                                    mb: 1,
                                                    p: 0,
                                                    "&:hover": {
                                                        bgcolor: "#ddd",
                                                        cursor: "pointer",
                                                    },
                                                }}
                                                onClick={() => {
                                                    navigate(`/training/detail/${row.careerId}`, {
                                                        state: { check: false, showCertification: true, classId: row.classId },
                                                    });
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        height: "80px",
                                                        display: "flex",
                                                        alignItems: "flex-start",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <ThumbnailBox thumbnail={row.careerImageUrl} />

                                                    <Box sx={{ flexGrow: 1, pl: 1.5, height: "100%" }}>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                width: "100%",
                                                                fontWeight: "bold",
                                                                mb: "5px",
                                                                overflowX: "hidden",
                                                                wordBreak: "break-all",
                                                            }}
                                                            className="ellipses"
                                                        >
                                                            {row.careerTitle}
                                                        </Typography>
                                                        <Typography className="ellipses line-clamp-3" variant="body2" sx={{ wordBreak: "break-all" }}>
                                                            {row.outLine}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </ListItemButton>
                                        </ListItem>
                                    </Box>
                                ))}
                            </>
                        ) : (
                            <NoData message="表示データがありません" />
                        )}
                    </>
                )}
            </List>
        </Box>
    );
};

export default Submission;
